export const CRM_URL = process.env.REACT_APP_CRM_URL;
export const LOGISTICS_URL = process.env.REACT_APP_LOGISTICS_URL;
export const LIBRARIES_URL = process.env.REACT_APP_LIBRARIES_URL;
